import { useEffect, useState } from 'react';

const REPLACEMENT_SLOTS = {
  deliveryOptions: 'slot_replace_delivery_options'
};

export type FilledSlots = {
  deliveryOptions: boolean;
};

const useCheckFilledSlots = () => {
  const [filledSlots, setFilledSlots] = useState<FilledSlots>({
    deliveryOptions: false
  });

  useEffect(() => {
    const webComponent =
      IS_WEB_COMPONENT && !import.meta.env.DEV ?
        (document.querySelector('scayle-checkout') ?? document.querySelector('ay-checkout'))
      : null;
    const container: Document | Element = webComponent ?? document;

    const checkSlots = () => {
      const newFilledSlots: FilledSlots = Object.fromEntries(
        Object.entries(REPLACEMENT_SLOTS).map(([key, slotName]) => [
          key,
          container.querySelector(`[slot="${slotName}"]`) !== null
        ])
      ) as FilledSlots;

      setFilledSlots(prev => (JSON.stringify(prev) !== JSON.stringify(newFilledSlots) ? newFilledSlots : prev));
    };

    checkSlots();

    const observer = new MutationObserver(checkSlots);
    observer.observe(container, { childList: true });

    return () => observer.disconnect();
  }, []);

  return filledSlots;
};

export default useCheckFilledSlots;
